import { createActions } from 'redux-actions';

export const { updateCustomFields } = createActions('UPDATE_CUSTOM_FIELDS');
